"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consumer = exports.Provider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Context = (0, react_1.createContext)(null);
var Provider = /** @class */ (function (_super) {
    __extends(Provider, _super);
    function Provider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Provider.prototype.render = function () {
        var _a = this.props, variant = _a.variant, color = _a.color, size = _a.size, status = _a.status;
        return ((0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: {
                variant: variant,
                color: color,
                size: size,
                status: status
            } }, { children: this.props.children || null })));
    };
    Provider.defaultProps = {
        variant: 'light',
        color: 'blue',
        size: 'large',
        status: 'info'
    };
    return Provider;
}(react_1.PureComponent));
exports.Provider = Provider;
var Consumer = /** @class */ (function (_super) {
    __extends(Consumer, _super);
    function Consumer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderChildren = function (container) {
            return container ? _this.props.children(container) : null;
        };
        return _this;
    }
    Consumer.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(Context.Consumer, { children: this.renderChildren });
    };
    return Consumer;
}(react_1.PureComponent));
exports.Consumer = Consumer;
//# sourceMappingURL=AlertContext.js.map